import React, { useState, useEffect } from "react";
import Select from "react-select";
import axios from "axios";
import { CONSENTIMIENTOS } from "../constants/consentimientos.js";
import '../styles/ModalFirmarConsentimientos.css';

export default function ModalFirmarConsentimientos({
  abierto,
  onClose,
  expediente
}) {
  const [tipo, setTipo] = useState(null);
  const [loading, setLoading] = useState(false);

  if (!abierto) return null;

  const firmar = async () => {
    if (!tipo) return;

    setLoading(true);
    try {
      console.log("TIPO ENVIADO:", tipo);
      console.log("TIPO VALUE:", tipo.value);
      // 1. Crear consentimiento
      const docRes = await axios.post(
        `/api/documentos/consentimiento`,
        null,
        {
          params: {
            expediente,
            tipo: tipo.value
          },
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`
          }
        }
      );

      // 2. Enviar a firma
      const envioRes = await axios.post(
        `/api/documentos/${docRes.data.id}/enviar-firma`,
        {},
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`
          }
        }
      );

      // 3. Abrir vista tablet
      const url = `${window.location.origin}/firma/${envioRes.data.token}`;
      window.location.replace(url);
      //window.open(url, "_blank");

      onClose();
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="modal-overlay">
      <div className="modal">
        <h3>Firmar consentimiento</h3>

        <Select
          options={CONSENTIMIENTOS}
          value={tipo}
          onChange={setTipo}
          placeholder="Selecciona un consentimiento"
        />

        <div className="acciones-modal">
          <button onClick={onClose}>Cancelar</button>
          <button onClick={firmar} disabled={!tipo || loading}>
            {loading ? "Preparando..." : "Continuar"}
          </button>
        </div>
      </div>
    </div>
  );
}
